import { fa_time } from "./getWeekDays";

export const MakeChartPattern = async (apiEndPOint, reqData) => {

    const req = reqData.name.toLowerCase().replace(/\s+/g, "");
    const reqProvider = reqData.id;
  
    const res = await apiEndPOint({ name: req, id: [reqProvider] });
    if (res.status) {
      const convertedData = {
        data: [],
      };
      
  
      let aa = res.data.sort(
        (a, b) => new Date(a?.startDate) - new Date(b?.startDate)
      );
      res.data.forEach((weekData) => {
        aa.map((item) => new Date(item.resultDate));
  
        const week = {
          weekStartDay: fa_time(weekData.startDate),
          weekEndDay: fa_time(weekData.endDate),
          data: [],
        };
  
        let currentResultDate = "";
        let relatedData = [];
        
        weekData.data.forEach((item) => {
          if (item.resultDate !== currentResultDate) {
            if (currentResultDate !== "") {
              week.data.push({
                resultDate: currentResultDate,
                relatedData: relatedData,
              });
            }
            currentResultDate = item.resultDate;
            relatedData = [];
          }
  
          relatedData.push(item);
        });
  
        week.data.push({
          resultDate: currentResultDate,
          relatedData: relatedData,
        });
  
        convertedData.data.push(week);
      });
  
      return convertedData;
    }
  };
  